export class VideoModule {

    constructor() {
        this.$youtubeTopVideo = $('.hero-video-youtube');
        this.$playButton = $(".hero-video-button");
        this.init();
    }

    init() {
        if (this.$youtubeTopVideo.length > 0) {
            this.initLoadYoutubeAPI();
        }
    }

    initLoadYoutubeAPI(){
        window.onYouTubeIframeAPIReady = this.onYouTubeIframeAPIReady.bind(this);
        var tag = document.createElement('script');
        tag.src = "//www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

    onYouTubeIframeAPIReady() {
        this.$youtubeTopVideo.each(function(index, value){
            var $container = $(value);
            var youtubeId = $container.data('youtubeId');
            var $videoTarget = $container.find('.hero-video-youtube-target');
            new YT.Player($videoTarget.get(0), {
                videoId: youtubeId,
                events: {
                    'onReady': onPlayerReady.bind(this),
                    'onStateChange': onPlayerStateChange.bind(this)
                },
                playerVars: {
                  'controls': 0,
                  'rel' : 0,
                  'modestbranding' : 1,
                  'showinfo' : 0,
                },
                wmode: 'opaque'
            });

            function onPlayerStateChange(event) {
                if (event.data == YT.PlayerState.ENDED) {
                    this.$playButton.show();
                    $container.removeClass('active');
                }

                if(event.data == YT.PlayerState.BUFFERING || event.data == YT.PlayerState.PLAYING){
                    this.$playButton.hide();
                    $container.addClass('active');
                }
            }

            function onPlayerReady(event) {
                this.$playButton.on('click', function(){
                    $container.css({'opacity': 1});
                    event.target.playVideo();
                });
            }
        }.bind(this));
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/sleeping-giants/assets/scripts/src/App/VideoModule.js